import React from "react";
import { getRandomColor, warnDeprecation } from "../../utils/helpers";
import { BorderRadius, Color, ColorVariant } from "../../utils/theme";
import { cx } from "../../utils/dom";

type TagProps = React.ComponentPropsWithoutRef<"span"> & {
  prepend?: React.ReactNode;
  append?: React.ReactNode;
  hashValue?: string;
  color?: Color;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  shape?: "pill" | "rounded" | "sharp";
  radius?: BorderRadius;
  variant?: ColorVariant;
};

export const Tag = React.forwardRef<HTMLDivElement, TagProps>(
  (
    {
      prepend,
      append,
      children,
      hashValue,
      color,
      size = "sm",
      /**@deprecated use radius instead */
      shape = "rounded",
      variant = "light",
      className,
      radius = "full",
      ...props
    },
    ref
  ) => {
    warnDeprecation("shape", "radius", shape);

    const randomColor = React.useMemo(() => {
      if (hashValue) {
        return getRandomColor(hashValue);
      }

      return "gray";
    }, []);

    return (
      <span
        className={cx(className, "p-tag")}
        data-radius={radius}
        data-size={size}
        data-color={color ?? randomColor}
        data-variant={variant}
        ref={ref}
        {...props}
      >
        {prepend && prepend}
        {children}
        {append && append}
      </span>
    );
  }
);

Tag.displayName = "Tag";
